import Node from '../node.js';
import { ENABLE_CACHING } from '../constants.js';

export default class NodeNumber extends Node
{
	constructor(pParent)
	{
		super(pParent);	
	}

	addUserInput(strName, optTypeName = PARAM_TYPE.ANY, parameterConfig = {}, bIsLoading = false, bAddOutput = true, bCheckInputsOnly = false)
	{
		let pInput = super.addUserInput(strName, optTypeName, parameterConfig, bIsLoading, bAddOutput, bCheckInputsOnly);
		pInput.setIsConnectorHidden(true);
		return pInput;
	}

	onInputChangedSubclass(strInputName)
	{
		if(!ENABLE_CACHING)
			return;

		// Since we don't do internal cooking, we only dirty the nodes connected
		// to this specific input, and mark ourselves clean. Otherwise, changing
		// any parameter on main params node would recook the whole graph, even
		// if it's only connected to the end node.
		this.markClean();
		this.getParent().dirtyUpstreamContainedNodesStartingWith(this, strInputName);
	}
	
	getType()
	{
		return 'number';
	}
	
	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		return inputValues['number'];
	}
}